/* eslint-disable no-irregular-whitespace */
import { ANTIVIRUS_BRAND } from 'reactApp/appHelpers/featuresHelpers/features/antivirusBrand';

export const verifiedFileByAntivirusDesktopText = `Файл проверен антивирусом${
    ANTIVIRUS_BRAND === 'default' ? '' : ` ${ANTIVIRUS_BRAND}`
} и безопасен для вашего компьютера`;
